import { styled } from 'helpers';
import { StyledTextfield } from 'TextField';

import { TextAreaProps } from './TextArea.types';

export const TextAreaStyled = styled(StyledTextfield)<TextAreaProps>`
  & .MuiInputBase-root {
    background-color: ${({ theme }) => theme.palette.common.white};
    padding: 0px;
  }
  & .MuiInputBase-root.Mui-disabled {
    background-color: ${({ theme }) => theme.palette.grey.A100};
  }
  & .MuiFormHelperText-root {
    margin-right: 0;
  }
`;
